// extracted by css-extract-rspack-plugin
export default {"Spinner":"kAaLlajTdtoo4BDp","spinner":"zo4uoPvXfHInlnjG","SpinnerAnimation":"xmlN72nGde8qzKxg"};